export default __webpack_public_path__ + "static/stanleyknifemark-6cffc9b42573d650b0028d73db467808.png";